import StepNavigation from "./StepNavigation.jsx";

function WizardFrame({
  title,
  steps,
  currentStep,
  maxStepReached,
  onStepSelect,
  children,
  wizardRef
}) {
  return (
    <section ref={wizardRef} className="landstar-wizard-shell">
      <div className="landstar-wizard-card">
        <div className="landstar-wizard-header">
          <div className="landstar-wizard-intro">
            <p className="landstar-kicker">Guided Redemption</p>
            <img
              src="/logos/landstar_logo.png"
              alt="Landstar"
              className="landstar-header-logo"
            />
            <h2>{title}</h2>
          </div>
        </div>

        <div className="landstar-wizard-progress-shell">
          <StepNavigation
            steps={steps}
            currentStep={currentStep}
            maxStepReached={maxStepReached}
            onStepSelect={onStepSelect}
          />
        </div>

        <div className="landstar-wizard-body">
          <div key={currentStep} className="landstar-wizard-stage landstar-stage-transition">
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WizardFrame;
